
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"594","height":"754","viewBox":"0 0 594 754"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M594 650.65c0-2.35-2.35-4.7-4.7-4.7h-2.34L572.87 653c-4.7 2.35-11.74 2.35-18.78 2.35-25.83 0-51.66-16.45-58.7-39.94v-2.34c-9.39-39.94-7.04-124.5 0-192.62v-2.34c-4.7-11.75-25.82-37.59-49.3-54.03-18.79-16.44-44.61-28.19-61.05-37.58h-2.34c-2.35-2.35-4.7-2.35-7.05-2.35h-2.35c-4.7-2.35-4.7-4.7 2.35-9.4 0 0 2.35 0 2.35-2.35 32.87-21.13 56.35-39.93 77.48-68.11 18.78-28.19 32.87-51.68 32.87-101 0-32.9-9.4-56.38-25.83-79.87-18.78-28.19-65.74-58.72-77.48-61.07L208.96 150.33h-2.35c-2.35 0-2.35 0-2.35-2.35V79.86c-7.04-7.04-23.48-25.84-42.26-42.28C138.52 16.44 117.4 4.7 103.3 0L0 101v2.35c0 2.35 2.35 4.7 4.7 4.7h2.34L21.13 101h18.78c35.22 0 54 28.19 54 56.38v516.76c2.35 7.04 18.79 25.84 39.92 42.28 23.47 21.14 44.6 32.88 61.04 37.58l103.3-101v-2.35c0-2.35-2.34-4.7-4.7-4.7h-2.34L277.04 653c-7.04 2.35-14.08 2.35-21.13 2.35h-9.39c-2.35 0-4.7-2.35-4.7-2.35V399.3c0-2.34 0-4.7 4.7-7.04l18.78-9.4h7.05c30.52 4.7 91.56 46.98 103.3 65.77 4.7 9.4 4.7 18.8 4.7 30.54v11.74C378 547.3 382.7 650.65 392.09 671.8c2.35 9.4 18.78 25.84 39.91 42.28 23.48 21.14 44.6 32.88 58.7 37.58l103.3-101zm-366.26-9.4c0 2.35 0 4.7-2.35 4.7h-2.35c-14.08-11.74-21.13-28.19-23.47-44.63v-422.8c0-2.35 0-2.35 2.34-4.7l21.13-18.8h2.35c2.35 0 2.35 0 2.35 2.36v483.87zm25.82-267.77s-2.34 0-2.34 2.35h-2.35a5.05 5.05 0 01-4.7-4.7v-230.2c0-2.34 2.35-4.7 4.7-7.04l54-46.98c2.35-2.35 4.7-2.35 14.09 2.35 7.04 4.7 14.08 9.4 18.78 14.1 28.17 25.83 44.6 61.06 44.6 93.95 2.36 77.51-46.95 126.84-126.77 176.17z"}})])
          )
        }
      }
    